const languageToEditorMode = {
  c: "c_cpp",
  cpp: "c_cpp",
  python: "python",
  python3: "python",
  java: "java",
};

export { languageToEditorMode };
